/*
 * Copyright (c) Worldline 2023.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {SignatureDto} from "../model/signatureDto";
import ActionEnum = SignatureDto.ActionEnum;

@Pipe({
    name: 'signatureAction'
})
export class SignatureActionPipe implements PipeTransform {

    transform(input: string, action: string): string {
        console.debug("signature action [input=" + input + " , action=" + action + "]")
        if (action) {
            switch (action) {
                case ActionEnum.Signature:
                    return input + '.signature';

                case ActionEnum.Approval:
                    return input + '.approval';

                case ActionEnum.FinalAgreement:
                    return input + '.finalagreement';

                case ActionEnum.Watermark:
                    return input + '.watermark';

                default:
                    return input;
            }
        } else {
            return input;
        }
    }

}
